import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

import { prepareOwnersToClient } from "./to-client/prepareOwnerToClient";
import prepareLocationsToClient from "./to-client/prepareSectorToClient";
import prepareFeaturesToClient from "./to-client/prepareFeaturesToClient";
import prepareBusinessTypeToClient from "./to-client/prepareBusinessTypeToClient";
import prepareBudgedToClient from "./to-client/prepareBudgetToClient";
import {
  C_CURRENCY,
  O_CURRENCY
} from "@/src-refactor/modules/shared/model/const/currency.conts";
import { GetArrangementsType } from "./to-client/prepareExtrasArray";
import { O_REALESTATE_TYPES } from "@/src-refactor/modules/shared/model/const/property/real-estate-type.const";
import { O_COMMISSION_RENT_ALL } from "@/src-refactor/modules/shared/model/const/property/comission_rent.const";
import { C_YES_AND_NOT } from "@/src-refactor/modules/shared/model/const/yes-and-not.conts";
import preparePicturesToClient from "./to-client/preparePicturesToClients";
import prepareDocumentsToClient from "./to-client/prepareDocumentsToClients";
import prepareCharacteristicToClient from "./to-client/prepareCaracteriticToClient";
import prepareVideosToClient from "./to-client/prepareVideosToClients";
import prepareSeoToClient from "./to-client/prepareSeoToClient";
import prepareAgentsToClient from "./to-client/prepareAgentsToClient";
import prepareVisitInfoToClient from "./to-client/prepareVisitInfoToClient";
import prepareAlterEstateToClient from "./to-client/prepareAlterEstateToClient";
import { IPropertyForm } from "../../components/property-form/util/schemas/property-schema/propertySchema";
import { CPropertyForm } from "../../components/property-form/util/schemas/property-schema/propertySchema";
import prepareConditionStatusToClient from "./to-client/prepareConditionStatusToClient";

const patchPropertyAdapter = (data: IPropertyDetailsResponse): IPropertyForm => {
  const owners = prepareOwnersToClient(data);
  const locations = prepareLocationsToClient(data);
  const features = prepareFeaturesToClient(data);
  const businessType = prepareBusinessTypeToClient(data);
  const arrangement = GetArrangementsType(data?.arrangement_id);
  const visitInfo = prepareVisitInfoToClient(data);
  const agentInfo = prepareAgentsToClient(data);
  const budge = prepareBudgedToClient(data);
  const seo = prepareSeoToClient(data);
  const videos = prepareVideosToClient(data);
  const documents = prepareDocumentsToClient(data);
  const pictures = preparePicturesToClient(data);
  const characteristic = prepareCharacteristicToClient(data);
  const alterEstate = prepareAlterEstateToClient(data);
  const conditionProperty = prepareConditionStatusToClient(data);
  return {
    ...CPropertyForm,
    ...characteristic,
    ...alterEstate,
    id_property: data?.id,
    owners_property: owners,
    city_property: locations.city,
    sector_property: locations.sector,
    latitude_property: locations.lat,
    longitude_property: locations.log,
    address_property: locations.address,
    reference_point_property: locations.reference,
    position_property: features.position as any[],

    //description_property
    // TODO - Check if this is the correct return type
    type_property: (data.realstatetype_id
      ? [O_REALESTATE_TYPES[data?.realstatetype_id]]
      : []) as any[],
    name_property: data?.name || "",
    business_types_property: businessType.business_type as any[],
    detail_business_property: businessType.detail_business_type as any[],
    uses_property: features.use as any[],
    condition_property: conditionProperty,
    associates_type_property: agentInfo.associates_type,
    arrangement_type_property: arrangement as any[],
    meter_construction_property: data?.sqm_construction || "",
    meter_land_property: data?.sqm_land || "",
    visit_type_property: visitInfo.visit_type_property as any[],
    is_habited_property: visitInfo.is_habited_property as any[],
    price_sale_property: budge.sale_price,
    currency_sale_property: budge.sale_currency as any[],
    price_rent_property: budge.rent_price,
    currency_rent_property: budge.rent_currency as any[],
    price_maintenance_property: data?.maintenance_fee || "",
    currency_maintenance_property: (data?.maintenance_currency_id
      ? [O_CURRENCY[data?.maintenance_currency_id]]
      : [C_CURRENCY.RD]) as any[],
    fee_sale_selling_agent_commission_percentage: data?.total_comission || "",
    fee_sale_percentage_commission_property: data?.guaranteed_comission || "",

    characteristics_frames_property: features.characteristics_frames as any[],
    characteristics_closets_property: features.characteristics_closets as any[],
    characteristics_cabinets_property: features.characteristics_cabinets as any[],
    characteristics_floors_property: features.characteristics_floors as any[],
    characteristics_windows_property: features.characteristics_windows as any[],
    characteristics_type_house_property:
      features.characteristics_type_house as any[],
    characteristics_roof_property: features.characteristics_roof as any[],
    characteristics_roof_form_property: features.characteristics_roof_form as any[],
    features_property: features.features as any[],
    characteristics_door_property: features.characteristics_doors as any[],

    brokers_property: agentInfo.agents,
    fee_rent: (data?.lease_commission
      ? [O_COMMISSION_RENT_ALL[data?.lease_commission]]
      : []) as any[],
    is_collection_property: (data?.is_collection
      ? [C_YES_AND_NOT.YES]
      : [C_YES_AND_NOT.NOT]) as any[],

    is_study_property: (data?.improvements_list?.some(
      imp => imp.feature_values_id == 28
    )
      ? [C_YES_AND_NOT.YES]
      : [C_YES_AND_NOT.NOT]) as any[],

    // documents
    // tareas_property: data?.tarea ?? "",
    registration_number: data?.property_title_number ?? "",
    notes_property: data?.loan_note ?? "",
    have_mortgage_property: (data?.has_loan
      ? [C_YES_AND_NOT.YES]
      : [C_YES_AND_NOT.NOT]) as any[],

    // multimedia
    images_property: pictures,
    drive_link_property: data?.google_drive_link ?? "",
    dropbox_link_property: data?.dropbox_link ?? "",
    tour_virtual_property: data?.realstate_tour_url ?? "",
    videos_property: videos,

    // documents
    file_title_property: documents.title,
    file_capture_details_property: documents.captureDetails,
    file_owner_id_property: documents.fileOwnerId,
    file_application_form_property: documents.fileApplicationForm,
    file_power_ownership_property: documents.filePowerOwnership,
    file_commercial_registry_property: documents.fileCommercialRegistry,
    file_property_contract_property: documents.filePropertyContract,

    // seo
    seo_description_en_property: seo.description_en,
    seo_keywords_en_property: seo.keywords_en,
    seo_short_description_en_property: seo.short_description_en,
    seo_title_en_property: seo.title_en,
    seo_description_es_property: seo.description_es,
    seo_keywords_es_property: seo.keywords_es,
    seo_short_description_es_property: seo.short_description_es,
    seo_title_es_property: seo.title_es
  } as any;
};
// TODO - Check if this is the correct return type
export default patchPropertyAdapter;
